import React, { useContext, useState } from 'react';
import { styled } from '@mui/material/styles';
import { 
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogActions,
    LinearProgress,
    TextField,
    Typography
} from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';


import UserContext from '../../../contexts/UserContext';
import ProjectContext from '../../../contexts/ProjectContext';
import {supportTheme} from '../../../theme';

import {
    DialogTextField,
    DialogFooter
} from './SupportDialogStyles';


export default function SupportDialogSubmitting(props){
    const { formState, setFormState, handleSubmit, handleClose, ticketStatus, submitProgress } = props
    const t = supportTheme
    const { konsolUser } = useContext(UserContext)
    const projectContext = useContext(ProjectContext)



    return (
        <React.Fragment>
            <DialogContent sx={{ 
                color: 'rgb(175, 175, 175)', 
                padding: t.size.panelInset, 
                pt: 10,
                gap: 2, 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                overflow: 'hidden',
            }}>

                <Box
                    sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: '60px',
                        width: '60px',
                        borderRadius: '50%',
                        backgroundColor: 'rgb(45, 55, 45)',
                        border: '1px solid rgb(72, 94, 72)',
                    }}
                >
                <CircularProgress size={60} sx={{ color: "rgb(175, 255, 175)" }}/>

                <SummarizeIcon
                    sx={{
                    position: "absolute",
                    fontSize: 40,
                    color: "rgb(175, 255, 175)",
                    }}
                />
                </Box>

                    <Typography sx={{...t.type.title}}>Submitting your request</Typography>           


                    <Box width="80%" sx={{ mt: 5 }}>
                        <Typography sx={{...t.type.body}}>{ticketStatus}...</Typography>
                        <LinearProgress
                            variant="determinate"
                            value={Math.min(submitProgress ?? 0, 100)}
                            color="success"
                            sx={{ height: 8, borderRadius: 999, width: '100%', mt: 1 }}
                        />     
                    </Box>


            </DialogContent>

        </React.Fragment>
    )
}